module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Weather/Cloud2-2548e8701da1ec4fa22f555287f9ef3d.svg";